// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3775059f","453":"aa4a6d9d","455":"dd0d90eb","977":"58f45fbe"}[chunkId] + ".chunk.js";
};